//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import contactMentorsForm from '~/mixins/contactMentorsForm.js'

export default {
  mixins: [contactMentorsForm],
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    answers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: {
        question: null,
      },
      invalidFields: {
        question: false,
      },
    }
  },
  computed: {
    formattedPlaceholder() {
      return this.answers.length > 0 ? this.answers[2][0] : ''
    },
  },
}
